import { ISnowplowContext } from '@mindtickle/snowplow-client/lib/core/interfaces/tracker';
export function getUserContext(
  user:
    | {
        id: string;
        name: string;
        email: string;
        sessionId: string;
        isWebView: string;
        locale?: string | undefined;
        freshchatRestoreId?: string | null | undefined;
        freshchatId?: string | undefined;
        isLoggedIn: boolean;
      }
    | undefined
) {
  return () =>
    ({
      schema: 'iglu:com.mindtickle.platform/User/jsonschema/1-0-0',
      data: {
        id: user?.id,
        sessionId: user?.sessionId,
        zipy_url: window.zipy?.getCurrentSessionURL?.() || 'zipy url not available',
        dd_url:
          window.DD_RUM?.getSessionReplayLink?.() || 'Datadog Session Replay url not available',
        name: user?.name,
        email: user?.email,
      },
    } as ISnowplowContext);
}
